<header class="topbar-header" [class.rail]="sidebarRail">
  <nav class="topbar">
    <div class="topbar__left">
      <button type="button" class="icon-btn" (click)="OnToggleSideBar()" aria-label="Toggle navigation">
        <i class="bi bi-list"></i>
      </button>

      <!-- agent select + switch button as one control (appTooltip would overwrite data-bs-toggle, so plain title here) -->
      <div class="agent-switch" *ngIf="isAdmin">
        <app-admin-select-agent-form [(ngModel)]="currentAgent" (agentChange)="selectAgentChange($event)">
        </app-admin-select-agent-form>
        <button type="button" class="agent-switch__btn" data-bs-toggle="offcanvas"
          data-bs-target="#chooseAgentOffcanvas" [attr.title]="'AGENT' | translate">
          <i class="bi bi-arrow-up-left-square"></i>
        </button>
      </div>
    </div>

    <div class="topbar__right">
      <div class="credit-chip d-none d-lg-flex" *ngIf="currentAgent">
        <i class="bi bi-wallet2"></i>
        <span class="credit-chip__amount">{{ currentAgent?.credit_remaining || 0 | number : ".2-2" }}</span>
        <span class="credit-chip__cur">{{ currentAgent?.currency || "THB" }}</span>
      </div>

      <button type="button" class="icon-btn d-none d-lg-inline-flex" (click)="svLanguage.openChooseLanguage()"
        [appTooltip]="'CHANGE_LANGUAGE' | translate" placement="bottom">
        <img [src]="svLanguage.getLang().image" height="16" alt="" />
      </button>

      <button type="button" class="icon-btn d-none d-lg-inline-flex" (click)="onChangeTheme()"
        [appTooltip]="'THEME' | translate" placement="bottom">
        <i class="bi" [class.bi-moon-stars-fill]="darkTheme" [class.bi-sun-fill]="!darkTheme"></i>
      </button>

      <button type="button" class="icon-btn d-none d-lg-inline-flex" data-bs-toggle="offcanvas"
        data-bs-target="#alertModal" aria-controls="offcanvasRight" [attr.title]="'NOTIFICATION' | translate">
        <i class="bi bi-bell"></i>
        <span class="icon-btn__dot" *ngIf="newNotiTotal > 0">
          <span class="visually-hidden">New alerts</span>
        </span>
      </button>

      <div class="user-menu dropdown">
        <button type="button" class="user-menu__btn" data-bs-toggle="dropdown" aria-expanded="false">
          <img class="user-menu__avatar" *ngIf="userProile?.user?.image && !avatarFailed"
            [src]="userProile?.user?.image | imgHost" alt="" (error)="avatarFailed = true" />
          <span class="user-menu__avatar user-menu__avatar--initial" *ngIf="!userProile?.user?.image || avatarFailed">
            {{ userInitial }}
          </span>
          <span class="user-menu__text d-none d-lg-flex">
            <span class="user-menu__name">{{ currentUser?.Username }}</span>
            <span class="user-menu__role">{{ currentUser.Role }}</span>
          </span>
          <i class="bi bi-chevron-down user-menu__chev d-none d-lg-block"></i>
        </button>

        <ul class="dropdown-menu dropdown-menu-end shadow">
          <ng-container *ngIf="currentAgent">
            <li class="d-block d-lg-none">
              <span class="dropdown-item-text user-menu__credit">
                <i class="bi bi-wallet2"></i>
                {{ currentAgent?.credit_remaining || 0 | number : ".2-2" }}
                <small>{{ currentAgent?.currency || "THB" }}</small>
              </span>
            </li>
            <li class="d-block d-lg-none dropdown-divider"></li>
          </ng-container>
          <li>
            <a [routerLink]="['', AppPath.profile, ProfilePath.detail]" class="dropdown-item">
              <i class="bi bi-person me-2"></i> {{ "PROFILE" | translate }}
            </a>
          </li>
          <li>
            <a class="dropdown-item" data-bs-toggle="offcanvas" data-bs-target="#AllLink"
              aria-controls="offcanvasRight">
              <i class="bi bi-folder-symlink me-2"></i> {{ "VARIOUS_LINKS" | translate }}
            </a>
          </li>
          <li>
            <a [routerLink]="['', AppPath.profile, ProfilePath.login]" class="dropdown-item">
              <i class="bi bi-clock-history me-2"></i> {{ "LOGIN_HISTORY" | translate }}
            </a>
          </li>
          <li>
            <a [routerLink]="['', AppPath.profile, ProfilePath.changePassword]" class="dropdown-item">
              <i class="bi bi-key me-2"></i> {{ "CHANGE_PASSWORD" | translate }}
            </a>
          </li>
          <li class="dropdown-divider"></li>
          <li class="d-block d-lg-none">
            <a class="dropdown-item" (click)="svLanguage.openChooseLanguage()">
              <i class="bi bi-translate me-2"></i> {{ "CHANGE_LANGUAGE" | translate }}
            </a>
          </li>
          <li class="d-block d-lg-none">
            <a class="dropdown-item" (click)="onChangeTheme()">
              <i class="bi me-2" [class.bi-moon-stars-fill]="darkTheme" [class.bi-sun-fill]="!darkTheme"></i>
              {{ "THEME" | translate }}
            </a>
          </li>
          <li class="d-block d-lg-none">
            <a class="dropdown-item" data-bs-toggle="offcanvas" data-bs-target="#alertModal">
              <i class="bi bi-bell me-2"></i> {{ "NOTIFICATION" | translate }}
            </a>
          </li>
          <li class="d-block d-lg-none dropdown-divider"></li>
          <li>
            <a href="javascript:;" class="dropdown-item" (click)="onLogout()">
              <i class="bi bi-power me-2"></i> {{ "LOG_OUT" | translate }}
            </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</header>

<div class="overlay-toggle-sidebar" (click)="OnToggleSideBar()" [ngClass]="{ 'overlay-open': sidebarOpen }"></div>

<aside class="sidebar-layout" [class.sidebar-open]="sidebarOpen" [class.rail]="sidebarRail">
  <div class="sidebar-brand">
    <a [routerLink]="['']" class="d-inline-flex">
      <img class="brand-logo sidebar-brand__logo" [src]="Config.LogoDark" [alt]="Config.YourBand.en" />
      <img class="brand-logo-w sidebar-brand__logo" [src]="Config.Logo" [alt]="Config.YourBand.en" />
      <img class="sidebar-brand__mark" [src]="Config.Favicon" [alt]="Config.YourBand.en" />
    </a>
    <button type="button" class="icon-btn sidebar-collapse" (click)="OnToggleSideBar()"
      aria-label="Collapse navigation">
      <i class="bi bi-chevron-double-left"></i>
    </button>
  </div>

  <div class="sidebar-content" [perfectScrollbar]="{}">
    <ul class="sidebar-menu" id="accordion-sidebar">
      <ng-container *ngFor="let item of sidebarMenu; let i = index">
        <li *ngIf="item.type === 'header'" class="menu-header">
          <span class="menu-header__no" *ngIf="item.prefixName">{{ item.prefixName }}</span>
          <span class="menu-header__label">{{ item.name | translate }}</span>
        </li>

        <li *ngIf="item.type === 'router'" class="menu-item">
          <a class="menu-link" href="javascript:;" [routerLink]="item.link" routerLinkActive="active"
            [attr.title]="sidebarRail ? (item.name | translate) : null">
            <img *ngIf="item.imageSrc" class="menu-link__img" [src]="item.imageSrc" alt="" />
            <i *ngIf="!item.imageSrc" [class]="'menu-link__icon ' + (item.iconClass || 'bi bi-dot')"></i>

            <span class="menu-link__label">{{ item.name | translate }}</span>

            <span class="menu-link__badges">
              <span *ngIf="item.badgesName && Badges[item.badgesName]" class="badge bg-danger rounded-pill">
                {{ Badges[item.badgesName] }}
              </span>
              <ng-container *ngIf="item.badgesName === 'WithdrawAuto'">
                <span class="badge bg-info rounded-pill" *ngIf="Badges.WithdrawPending !== 0">
                  {{ Badges.WithdrawPending }}
                </span>
                <span class="badge bg-danger rounded-pill" *ngIf="Badges.WithdrawFailed !== 0">
                  {{ Badges.WithdrawFailed }}
                </span>
              </ng-container>
            </span>

            <span class="menu-link__realtime" *ngIf="item.realTimeWork">
              <ng-container *ngIf="item.realTimeWork === 'LogOnline'">
                <i *ngIf="LogOnline" class="bi bi-arrow-left-right"></i>
              </ng-container>
              <ng-container *ngIf="item.realTimeWork === 'TransferOnline'">
                <i *ngIf="TransferOnline" class="bi bi-arrow-left-right"></i>
              </ng-container>
            </span>
          </a>
        </li>

        <li *ngIf="item.type === 'menu'" class="menu-item menu-item--group">
          <a class="menu-link menu-link--group" href="#collapse-menu-{{ i }}" data-bs-toggle="collapse"
            [attr.aria-expanded]="item.expanded ? true : false" (click)="onMenuGroupClick(item)"
            [attr.title]="sidebarRail ? (item.name | translate) : null">
            <img *ngIf="item.imageSrc" class="menu-link__img" [src]="item.imageSrc" alt="" />
            <i *ngIf="!item.imageSrc" [class]="'menu-link__icon ' + (item.iconClass || 'bi bi-dot')"></i>

            <span class="menu-link__label">{{ item.name | translate }}</span>

            <span class="menu-link__badges">
              <span *ngIf="item.badgesName && Badges[item.badgesName]" class="badge bg-danger rounded-pill">
                {{ Badges[item.badgesName] }}
              </span>
            </span>

            <i class="bi bi-chevron-down menu-link__chev"></i>
          </a>

          <ul id="collapse-menu-{{ i }}" class="menu-sub collapse" data-bs-parent="#accordion-sidebar"
            [class.show]="item.expanded">
            <li *ngFor="let menu of item.menuList">
              <a class="menu-sub__link" href="javascript:;" [routerLink]="menu.link" routerLinkActive="active">
                <span class="menu-link__label">{{ menu.name | translate }}</span>
                <span *ngIf="menu.badgesName && Badges[menu.badgesName]" class="badge bg-danger rounded-pill">
                  {{ +Badges[menu.badgesName] }}
                </span>
              </a>
            </li>
          </ul>
        </li>
      </ng-container>
    </ul>
  </div>
</aside>

<div class="page-wrapper" [class.rail]="sidebarRail">
  <div class="page-content">
    <router-outlet></router-outlet>
    <div class="page-foot">
      Copyright © 2021. All Right Reserved. ({{ Config?.createBy?.name || "GOODGAME66" }} {{ svApp.version }})
    </div>
  </div>
</div>

<app-alert-modal [(newItemTotal)]="newNotiTotal"></app-alert-modal>

<div class="offcanvas offcanvas-end" tabindex="-1" id="AllLink" aria-labelledby="offcanvasRightLabel">
  <div class="offcanvas-header">
    <h5 class="offcanvas-title" id="offcanvasRightLabel">
      {{ "LINKS_FOR_USE" | translate }}
    </h5>
    <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
  </div>
  <div class="offcanvas-body">
    <div class="highlight">
      <div class="mb-3">
        {{ "LINK_TO_PLAY" | translate }}
        <code data-lang="html">
          {{ " https://{host}/login?a={agent_code}" }}
        </code>
      </div>
      <div class="mb-3">
        {{ "LINK_TO_APPLY_FROM_MAIN_PAGE" | translate }}
        <code data-lang="html">
          {{ "https://{host}/register?a={agent_code}" }}
        </code>
      </div>
      <div class="mb-3">
        {{ "LINK_TO_APPLY_FROM_LINE" | translate }}
        <code data-lang="html">
          {{ "https://{host}/register?referer=LINE&agun={agent_code}" }}
        </code>
      </div>
      <div class="mb-3">
        {{ "LOGIN_LINK_FOR_REDIRECT_TOKEN" | translate }}
        <code data-lang="html">
          {{ "https://{host}/redirect/token?t={token}" }}
        </code>
      </div>
      <div class="mb-3">
        {{ "LOGIN_LINK_FOR_REDIRECT_LOGIN" | translate }}
        <code data-lang="html">
          {{ "https://{host}/redirect/pass-login?username={user}&password={pass}" }}
        </code>
      </div>
    </div>
  </div>
</div>

<div class="d-none">
  <audio *ngFor="let item of currentSoundSetting | keyvalue" [id]="$any(item.value).name">
    <source [src]="$any(item.value).path" />
  </audio>
</div>

<button type="button" class="btn d-none" data-bs-target="#memberCreditFormOffcanvas" data-bs-toggle="offcanvas"
  id="btn-open-member-credit-form">
  open memberCreditFormOffcanvas
</button>
<app-credit-form-offcanvas [id]="'memberCreditFormOffcanvas'" [isAdd]="memberCreditFormData.is_add"
  [memberId]="memberCreditFormData.member_id">
</app-credit-form-offcanvas>

<button type="button" class="btn d-none" data-bs-target="#mainClearTurnoverMemberOffCanvas" data-bs-toggle="offcanvas"
  id="btn-open-clear-turnover-member">
  open memberCreditFormOffcanvas
</button>

<app-choose-agent-offcanvas (submitAgent)="selectAgentChange($event)"></app-choose-agent-offcanvas>
